

// // src/App.js
// import React from 'react';
// import { useAuth } from './context/AuthContext';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import { AuthProvider } from './context/AuthContext';
// import Layout from './components/common/Layout';
// import Login from './pages/user/Login';

// // User Pages
// import Home from './pages/user/Home';
// import Services from './pages/user/Services';
// import Certifications from './pages/user/Certification';
// import ServiceDetail from './pages/user/ServiceDetail';
// import ProjectDetails from './pages/user/ProjectDetails';
// import Projects from './pages/user/Projects';
// import About from './pages/user/About';
// import Contact from './pages/user/Contact';

// // Admin Pages
// import AdminDashboard from './pages/admin/Dashboard';
// import AdminServices from './pages/admin/Services';
// import AdminProjects from './pages/admin/Projects';
// import AdminMedia from './pages/admin/Media';
// import AdminCertifications from './pages/admin/Certifications';
// import AdminSettings from './pages/admin/Settings';
// import AdminProjectDetail from './pages/admin/ProjectDetail';
// import AdminServiceDetail from './pages/admin/ServiceDetail';
// import AdminMediaDetail from './pages/admin/MediaDetail';

// // Admin Management Pages
// import UserManagement from './pages/admin/UserManagement';
// import AdminManagement from './pages/admin/AdminManagement';

// // Components
// import ProtectedRoute from './components/common/ProtectedRoute';
// import Unauthorized from './pages/user/Unauthorized';

// function App() {
//   return (
//     <AuthProvider>
//       <Router>
//         <Routes>
//           {/* Public Routes */}
//           <Route path="/" element={<Layout><Home /></Layout>} />
//           <Route path="/services" element={<Layout><Services /></Layout>} />
//           <Route path="/certifications" element={<Layout><Certifications /></Layout>} />
//           <Route path="/services/:id" element={<Layout><ServiceDetail /></Layout>} />
//           <Route path="/projects/:id" element={<Layout><ProjectDetails /></Layout>} />
//           <Route path="/projects" element={<Layout><Projects /></Layout>} />
//           <Route path="/about" element={<Layout><About /></Layout>} />
//           <Route path="/contact" element={<Layout><Contact /></Layout>} />
//           <Route path="/login" element={<Login />} />
//           <Route path="/unauthorized" element={<Unauthorized />} />

//           {/* Admin Dashboard */}
//           <Route path="/admin" element={
//             <ProtectedRoute adminOnly>
//               <AdminDashboard />
//             </ProtectedRoute>
//           } />

//           {/* Admin Services Management */}
//           <Route path="/admin/services" element={
//             <ProtectedRoute requiredPermission="manage_services">
//               <AdminServices />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/services/:id" element={
//             <ProtectedRoute requiredPermission="manage_services">
//               <AdminServiceDetail />
//             </ProtectedRoute>
//           } />

//           {/* Admin Projects Management */}
//           <Route path="/admin/projects" element={
//             <ProtectedRoute requiredPermission="manage_projects">
//               <AdminProjects />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/projects/:id" element={
//             <ProtectedRoute requiredPermission="manage_projects">
//               <AdminProjectDetail />
//             </ProtectedRoute>
//           } />

//           {/* Admin Media Management */}
//           <Route path="/admin/media" element={
//             <ProtectedRoute requiredPermission="manage_media">
//               <AdminMedia />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/media/:id" element={
//             <ProtectedRoute requiredPermission="manage_media">
//               <AdminMediaDetail />
//             </ProtectedRoute>
//           } />

//           {/* Admin Certifications Management */}
//           <Route path="/admin/certifications" element={
//             <ProtectedRoute requiredPermission="manage_certificates">
//               <AdminCertifications />
//             </ProtectedRoute>
//           } />

//           {/* User Management (for admins with manage_users permission) */}
//           <Route path="/admin/users" element={
//             <ProtectedRoute requiredPermission="manage_users">
//               <UserManagement />
//             </ProtectedRoute>
//           } />
//           <Route path="/admin/user-management" element={
//             <ProtectedRoute requiredPermission="manage_users">
//               <UserManagement />
//             </ProtectedRoute>
//           } />

//           {/* Admin Management (Super Admin Only) */}
//           <Route path="/admin/admin-management" element={
//             <ProtectedRoute>
//               {({ isSuperAdmin }) => 
//                 isSuperAdmin ? <AdminManagement /> : <Navigate to="/unauthorized" />
//               }
//             </ProtectedRoute>
//           } />

//           {/* Admin Settings */}
//           <Route path="/admin/settings" element={
//             <ProtectedRoute requiredPermission="manage_settings">
//               <AdminSettings />
//             </ProtectedRoute>
//           } />

//           {/* Catch all route */}
//           <Route path="*" element={<Navigate to="/" />} />
//         </Routes>
//       </Router>
//     </AuthProvider>
//   );
// }

// export default App;



// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { AIProvider } from './context/AIContext';
import Layout from './components/common/Layout';
import Login from './pages/user/Login';

// User Pages
import Home from './pages/user/Home';
import Services from './pages/user/Services';
import Certifications from './pages/user/Certification';
import ServiceDetail from './pages/user/ServiceDetail';
import ProjectDetails from './pages/user/ProjectDetails';
import Projects from './pages/user/Projects';
import About from './pages/user/About';
import Contact from './pages/user/Contact';
//import AIChatPage from './pages/user/AIChatPage'; // Add AI Chat page

// Admin Pages
import AdminDashboard from './pages/admin/Dashboard';
import AdminServices from './pages/admin/Services';
import AdminProjects from './pages/admin/Projects';
import AdminMedia from './pages/admin/Media';
import AdminCertifications from './pages/admin/Certifications';
import AdminSettings from './pages/admin/Settings';
import AdminProjectDetail from './pages/admin/ProjectDetail';
import AdminServiceDetail from './pages/admin/ServiceDetail';
import AdminMediaDetail from './pages/admin/MediaDetail';
import AISettings from './pages/admin/AISettings';
// Admin Management Pages
import UserManagement from './pages/admin/UserManagement';
import AdminManagement from './pages/admin/AdminManagement';

// Components
import ProtectedRoute from './components/common/ProtectedRoute';
import Unauthorized from './pages/user/Unauthorized';
import AIChatbot from './components/user/AIChatbot'; // Add AI Chatbot component

function App() {
  return (
    <AuthProvider>
      <AIProvider>
        <Router>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <Layout>
                <Home />
                <AIChatbot /> {/* Add chatbot to home */}
              </Layout>
            } />
            
            <Route path="/services" element={
              <Layout>
                <Services />
                <AIChatbot /> {/* Add chatbot to services */}
              </Layout>
            } />
            
            <Route path="/certifications" element={
              <Layout>
                <Certifications />
                <AIChatbot /> {/* Add chatbot to certifications */}
              </Layout>
            } />
            
            <Route path="/services/:id" element={
              <Layout>
                <ServiceDetail />
                <AIChatbot /> {/* Add chatbot to service detail */}
              </Layout>
            } />
            
            <Route path="/projects/:id" element={
              <Layout>
                <ProjectDetails />
                <AIChatbot /> {/* Add chatbot to project detail */}
              </Layout>
            } />
            
            <Route path="/projects" element={
              <Layout>
                <Projects />
                <AIChatbot /> {/* Add chatbot to projects */}
              </Layout>
            } />
            
            <Route path="/about" element={
              <Layout>
                <About />
                <AIChatbot /> {/* Add chatbot to about */}
              </Layout>
            } />
            
            <Route path="/contact" element={
              <Layout>
                <Contact />
                <AIChatbot /> {/* Add chatbot to contact */}
              </Layout>
            } />
            
            {/* AI Chat Page (Optional full-page chat) */}

            
            <Route path="/login" element={<Login />} />
            <Route path="/unauthorized" element={<Unauthorized />} />

            {/* Admin Dashboard */}
            <Route path="/admin" element={
              <ProtectedRoute adminOnly>
                <AdminDashboard />
              </ProtectedRoute>
            } />

            {/* Admin Services Management */}
            <Route path="/admin/services" element={
              <ProtectedRoute requiredPermission="manage_services">
                <AdminServices />
              </ProtectedRoute>
            } />
            <Route path="/admin/services/:id" element={
              <ProtectedRoute requiredPermission="manage_services">
                <AdminServiceDetail />
              </ProtectedRoute>
            } />

            {/* Admin Projects Management */}
            <Route path="/admin/projects" element={
              <ProtectedRoute requiredPermission="manage_projects">
                <AdminProjects />
              </ProtectedRoute>
            } />


            {/* Admin Projects Management */}
            <Route path ="/admin/ai-settings" element={
              <ProtectedRoute requiredPermission="manage_ai_settings">
                <AISettings />
              </ProtectedRoute>
            } />
            <Route path="/admin/projects/:id" element={
              <ProtectedRoute requiredPermission="manage_projects">
                <AdminProjectDetail />
              </ProtectedRoute>
            } />

            {/* Admin Media Management */}
            <Route path="/admin/media" element={
              <ProtectedRoute requiredPermission="manage_media">
                <AdminMedia />
              </ProtectedRoute>
            } />
            <Route path="/admin/media/:id" element={
              <ProtectedRoute requiredPermission="manage_media">
                <AdminMediaDetail />
              </ProtectedRoute>
            } />

            {/* Admin Certifications Management */}
            <Route path="/admin/certifications" element={
              <ProtectedRoute requiredPermission="manage_certificates">
                <AdminCertifications />
              </ProtectedRoute>
            } />

            {/* User Management (for admins with manage_users permission) */}
            <Route path="/admin/users" element={
              <ProtectedRoute requiredPermission="manage_users">
                <UserManagement />
              </ProtectedRoute>
            } />
            <Route path="/admin/user-management" element={
              <ProtectedRoute requiredPermission="manage_users">
                <UserManagement />
              </ProtectedRoute>
            } />

            {/* Admin Management (Super Admin Only) */}
            <Route path="/admin/admin-management" element={
              <ProtectedRoute>
                {({ isSuperAdmin }) => 
                  isSuperAdmin ? <AdminManagement /> : <Navigate to="/unauthorized" />
                }
              </ProtectedRoute>
            } />

            {/* Admin Settings */}
            <Route path="/admin/settings" element={
              <ProtectedRoute requiredPermission="manage_settings">
                <AdminSettings />
              </ProtectedRoute>
            } />

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </Router>
      </AIProvider>
    </AuthProvider>
  );
}

export default App;
